<template>
  <v-container fluid align-start ma-0 pa-2 class="epms9063-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnExcel="btnExcel()"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Ship No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line                            
                            outlined
                            dense
                            label=""
                            @change="shipNoChange()"
                          ></v-select>
                      </v-col>
                      <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Block : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="block"
                            :items="blockList"
                            item-value="block"
                            return-object
                            single-line                            
                            outlined
                            dense
                            label="Select"
                            @change="changeBlock()"
                          ></v-select>
                      </v-col>

                      <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">PSD from : </span>
                      <v-col cols="1">
                        <DxDateBox
                          :value="stDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms9063" 
                    class="hipGridHeight1_1" 
                    :ref="epms9063Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="matlSpec" caption="Material Spec." width="15%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="div" caption="Div" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <!-- <Month 1st> -->
                    <DxColumn caption="Mon1" width="16%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partWgt1" caption="BOM" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="whWgt1" caption="W/H" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="delyWgt1" caption="Dely" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="ndelyWgt1" caption="NY" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <!-- <template #mon1HeaderTemp>
                        <div>  {{ this.strMon1 }}  </div>
                      </template> -->
                    <DxColumn caption="Mon2" width="16%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partWgt2" caption="BOM" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="whWgt2" caption="W/H" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="delyWgt2" caption="Dely" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="ndelyWgt2" caption="NY" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <!-- <Month 3rd> -->
                    <DxColumn caption="Mon3" width="16%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partWgt3" caption="BOM" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="whWgt3" caption="W/H" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="delyWgt3" caption="Dely" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="ndelyWgt3" caption="NY" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <!-- <Month 4th> -->
                    <DxColumn caption="Mon4" width="16%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partWgt4" caption="BOM" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="whWgt4" caption="W/H" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="delyWgt4" caption="Dely" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="ndelyWgt4" caption="NY" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <!-- <Month 5th> -->
                    <DxColumn caption="Mon5" width="16%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partWgt5" caption="BOM" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="whWgt5" caption="W/H" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="delyWgt5" caption="Dely" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="ndelyWgt5" caption="NY" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxPaging :enabled="true" :page-size="60" />
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getYearFormat, getDateFormat, getFirstDate, getLastDate, getNumComma, getStringToDate, getDateToStringDte} from '@/utils/common.js'
import { epms9063, epms9063Xls } from '@/api/view/hip/91/epms9063'
import { getShipNoList1, epms9000_block} from '@/api/view/hip/common/common'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms9063',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox
  },

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epms9063Ref: 'epms9063Ref',
      gridMainList: [],
      shipNoList: [],
      blockList: [],
      makerCd: this.$store.state.user.makerCd,
      stDte: '',
      edDte: '',
      shipNo: '',
      block : '',
      strMon: '',
      strMon1: '',
      strMon2: '',
      strMon3: '',
      strMon4: '',
      strMon5: ''

    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9063Ref)
    },
  },
  mounted() {
    this.init()
    this.getList()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let comParams = {
          shipNo: this.shipNo,
          makerCd: this.$store.state.user.makerCd,
          delyNoteDiv: "",
          whYn: "",
          incNotPo: "Y"
        }
        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList1(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

        await epms9000_block(comParams).then(res => {
          this.blockList.push('')
          res.list.forEach(e => {
            this.blockList.push(e.block)
          });
          this.block = this.blockList[0] ;
        })

      } finally {
      this.endLoading()
      }
    },
    init() {

      this.stDte = getFirstDate('m')
      // this.strMon = this.stDte.substr(0, 7) 
      // let tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
      // this.edDte =  getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0))
      
      // this.strMon1 = this.strMon.substr(0,4) + "-" +  this.strMon.substr(4,2)
      // tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 1))
      // this.strMon2 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
      // tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 2))
      // this.strMon3 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
      // tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 3))
      // this.strMon4 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
      // tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
      // this.strMon5 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)

    },
    async getBlockList(){
      try {
        this.openLoading('searching')
        let comParams = {
          shipNo: this.shipNo,
          makerCd: this.$store.state.user.makerCd,
          delyNoteDiv: "",
          whYn: "",
          incNotPo: "Y"
        }
        await epms9000_block(comParams).then(res => {
          this.blockList.push('')
          res.list.forEach(e => {
            this.blockList.push(e.block)
          });
          this.block = this.blockList[0]
        })
      } finally {
        this.endLoading()
      }
    },
    async getMainList(){
      try {
        this.openLoading('searching')

        this.strMon = this.stDte.substr(0, 7).replace("-", "") ; 
        let tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
        this.edDte =  getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0))

        this.strMon1 = this.strMon.substr(0,4) + "-" +  this.strMon.substr(4,2)
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 1))
        this.strMon2 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 2))
        this.strMon3 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 3))
        this.strMon4 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
        this.strMon5 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)

        let params = {
          makerCd: this.$store.state.user.makerCd,
          stDte  : this.stDte,
          edDte  : this.edDte,
          shipNo : this.shipNo,
          block  : this.block == 'All' || !this.block ? '%' : blockList[0],
          strMon : this.strMon
        }

        // console.log('St date', this.stDte )
        // console.log('Ed date', this.edDte )
        // console.log('strMon', this.strMon)
        // console.log('shipNo', this.shipNo)
        // console.log('block', this.block)
        
        await epms9063(params).then(res => {
          let list = []
          let cnt = 1;

          // if (res.list.length >> 0) {
          //   this.strMon1 = res.list[0].mon1 
          //   this.strMon2 = res.list[0].mon2 
          //   this.strMon3 = res.list[0].mon3 
          //   this.strMon4 = res.list[0].mon4 
          //   this.strMon5 = res.list[0].mon5 
          // }
          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ , no: e.no, matlSpec: e.matlSpec,  div : 'QTY', 
                partWgt1: e.partQty1, whWgt1: e.whQty1, delyWgt1: e.delyQty1,  ndelyWgt1: e.ndelyQty1, 
                partWgt2: e.partQty2, whWgt2: e.whQty2, delyWgt2: e.delyQty2,  ndelyWgt2: e.ndelyQty2, 
                partWgt3: e.partQty3, whWgt3: e.whQty3, delyWgt3: e.delyQty3,  ndelyWgt3: e.ndelyQty3,
                partWgt4: e.partQty4, whWgt4: e.whQty4, delyWgt4: e.delyQty4,  ndelyWgt4: e.ndelyQty4,
                partWgt5: e.partQty5, whWgt5: e.whQty5, delyWgt5: e.delyQty5,  ndelyWgt5: e.ndelyQty5
               
              },
              {
                id: cnt++ , no: e.no, matlSpec: e.matlSpec,  div : 'WGT', 
                partWgt1: e.partWgt1, whWgt1: e.whWgt1, delyWgt1: e.delyWgt1,  ndelyWgt1: e.ndelyWgt1, 
                partWgt2: e.partWgt2, whWgt2: e.whWgt2, delyWgt2: e.delyWgt2,  ndelyWgt2: e.ndelyWgt2, 
                partWgt3: e.partWgt3, whWgt3: e.whWgt3, delyWgt3: e.delyWgt3,  ndelyWgt3: e.ndelyWgt3, 
                partWgt4: e.partWgt4, whWgt4: e.whWgt4, delyWgt4: e.delyWgt4,  ndelyWgt4: e.ndelyWgt4, 
                partWgt5: e.partWgt5, whWgt5: e.whWgt5, delyWgt5: e.delyWgt5,  ndelyWgt5: e.ndelyWgt5 
              }
              
            )
          });
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    //Get the day from based date after n months 
   getAddMonths(baseDte, intMons){
      let tmpDte = baseDte.setMonth(baseDte.getMonth() + intMons );
      return tmpDte
    },
    shipNoChange(){
      this.getBlockList()
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    // btnPrint(){
    //   let mactGbn = this.mAct
    //   mactGbn = mactGbn.split(' : ')
    //   const param = {
    //     fileName: 'epms9063prt.jrxml',
    //     as_ship_no: this.shipNo,
    //     as_m_act: mactGbn[0],
    //   }
    //   this.openLoading('searching')
    //   reportView(param)
    //   .finally(() => {
    //     this.endLoading()
    //   })
    // },
    btnExcel(){
      this.openLoading('searching')
      const param = {
          makerCd: this.$store.state.user.makerCd,
          stDte: this.stDte,
          edDte: this.edDte,
          shipNo: this.shipNo,
          block : this.block == 'All' || !this.block ? '%' : blockList[0],
          strMon: this.strMon
      }
      epms9063Xls(param)
      this.endLoading()
    },
    //cell merge
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.caption === 'No' || e.column.caption === 'Material Spec.') 
          {
            if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'no')){
              e.cellElement.setAttribute('rowspan', 2)
            }else {
              e.cellElement.style.display = 'none'
            }
        }
      } else {
        if(e.column.caption === 'Mon1'){
          e.cellElement.innerText = this.strMon1;
        }else if(e.column.caption === 'Mon2'){
          e.cellElement.innerText = this.strMon2;
        }else if(e.column.caption === 'Mon3'){
          e.cellElement.innerText = this.strMon3; 
        }else if(e.column.caption === 'Mon4'){
          e.cellElement.innerText = this.strMon4; 
        }else if(e.column.caption === 'Mon5'){
          e.cellElement.innerText = this.strMon5; 
        }
      }

    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
  }
}
</script>
<style lang="scss" scoped>
.epms9063-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>